import { useCallback, useState } from 'react';

import type { EditorActions } from '@atlaskit/editor-core';

import { fg } from '@confluence/feature-gating';

import { getAllSmartLinks } from '../services/links';

export const useInviteFromLinkExperimentEditor = () => {
	const [startingLinks, setStartingLinks] = useState<Set<string>>();

	const onEditorReady = useCallback(async (editorActions: EditorActions) => {
		const adf = await editorActions.getValue();
		const links = getAllSmartLinks(adf);
		setStartingLinks(links);
	}, []);

	return {
		onEditorReady: fg('invite_on_link_insert_confluence_gate') ? onEditorReady : undefined,
		startingLinks,
	};
};
